var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-button',_vm._g({attrs:{"label":_vm.label,"icon":_vm.icon,"disable":_vm.disable,"loading":_vm.loading,"custom-style":"margin-bottom: 0"}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }